import { inject, Injectable } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { OauthService } from '@tiltgroup/web-components';
import { IntercomService } from '@services/intercom.service';

/**
 * Starts login and Intercom once per app load. The private layout is recreated
 * whenever the visitor comes back from a public page, which must not start them again.
 */
@Injectable({ providedIn: 'root' })
export class PrivateAppStartupService {
  private _oauthService = inject(OauthService);
  private _oidcSecurityService = inject(OidcSecurityService);
  private _intercomService = inject(IntercomService);
  private _started = false;

  start(): void {
    if (this._started) {
      return;
    }
    this._started = true;

    this._oidcSecurityService.getConfiguration().subscribe((res) => {
      this._oauthService.authConfig = res;
      this._oauthService.subscribeToEvents();
      this._oauthService.checkAuth();
    });

    this._intercomService.initIntercom();
  }
}
